const BannerSection = ({ image, title }) => {
    return (<section id="custompages_banner" style={{ backgroundImage: `url("https://adminaccess.inquirely.com/inquirely//public/uploads/${image ? image : "home-banner.png"}")` }}>
        <div class="container">
            <h1>{title}</h1>
        </div>
    </section>)
} 

export default BannerSection;